import { useStowageStore } from 'src/context/StowageContext';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';
import { StowagePlanChange } from 'src/types/ViewModel/Stowage/StowagePlanChange';
import { useStowageUrlChangeHandler } from 'src/hooks/stowage/urlHandler/useStowageUrlChangeHandler';
import { cleanStowagePlanData, copyUpdatedStowagePlanMetaData } from 'src/factory/Stowage/StowagePlanFactory';
import { sortStowagePlans } from 'src/utils/stowage/stowagePlanUtils';
import { useRotationStore } from 'src/context/RotationContext';

export const useStowageUpdateHander = () => {
    const { setStowagePlans, stowagePlans, setActiveStowagePlan, setStowagePlanChanges, stowagePlanChanges } = useStowageStore();
    const {
        setSelectedStowageRotationPortCall,
        setSelectedStowageRotationBerthCall,
        selectedStowageRotationBerthCall,
        selectedStowageRotationPortCall,
    } = useRotationStore();
    const { setStowageDataInStowagePlan } = useStowageUrlChangeHandler();

    const updateStowagePlansOnAdd = (stowagePlan: StowagePlan, originalStowagePlan?: StowagePlan, skipSetActiveStowagePlan?: boolean) => {
        const indexOfStowagePlan = stowagePlans.findIndex((sp) => sp.stowagePlanGuid === stowagePlan.stowagePlanGuid);

        if (indexOfStowagePlan > -1) {
            stowagePlans[indexOfStowagePlan] = originalStowagePlan ? copyUpdatedStowagePlanMetaData(originalStowagePlan, stowagePlan) : stowagePlan;
            stowagePlan = stowagePlans[indexOfStowagePlan];
        } else {
            stowagePlans.push(stowagePlan);
        }

        const _stowagePlans = sortStowagePlans(stowagePlans);
        setStowagePlans([..._stowagePlans]);

        if (!skipSetActiveStowagePlan) {
            setActiveStowagePlan({ ...stowagePlan });
        }

        return { updatedStowagePlan: stowagePlan, updatedStowagePlans: _stowagePlans };
    };

    const updateActiveStowagePlan = (stowagePlan: StowagePlan) => setActiveStowagePlan({ ...stowagePlan });

    const updateStowagePlanChanges = (
        updatedStowagePlanChanges: StowagePlanChange[],
        stowagePlan: StowagePlan,
        updatedStowagePlans: StowagePlan[]
    ) => {
        const _stowagePlanChanges = [...stowagePlanChanges];

        for (const updatedStowagePlanChange of updatedStowagePlanChanges) {
            const index = _stowagePlanChanges.findIndex((spc) => spc.stowagePlanChangeGuid === updatedStowagePlanChange.stowagePlanChangeGuid);
            if (index > -1) {
                _stowagePlanChanges[index] = updatedStowagePlanChange;
            } else {
                _stowagePlanChanges.push(updatedStowagePlanChange);
            }
        }
        stowagePlan = cleanStowagePlanData(stowagePlan);

        setStowagePlanChanges([..._stowagePlanChanges]);
        return setStowageDataInStowagePlan(_stowagePlanChanges, stowagePlan, updatedStowagePlans);
    };

    const updateSelectedStowageItems = (stowagePlan: StowagePlan) => {
        if (selectedStowageRotationPortCall) {
            const updatedPortCall = stowagePlan.rotation.find((pc) => pc.portCallGuid === selectedStowageRotationPortCall.portCallGuid);
            setSelectedStowageRotationPortCall(updatedPortCall ? { ...updatedPortCall } : null);
        }
        if (selectedStowageRotationBerthCall) {
            const updatedBerthCall = stowagePlan.berthCalls.find((bc) => bc.berthCallGuid === selectedStowageRotationBerthCall.berthCallGuid);
            setSelectedStowageRotationBerthCall(updatedBerthCall ? { ...updatedBerthCall } : null);
        }
    };

    return {
        updateStowagePlansOnAdd,
        updateStowagePlanChanges,
        updateActiveStowagePlan,
        updateSelectedStowageItems,
    };
};
